import { CustomError } from "types/error";

function isCustomError(error: unknown): error is CustomError {
  return (
    typeof error === "object" &&
    error !== null &&
    "message" in error &&
    typeof (error as Record<string, unknown>).message === "string"
  );
}

function toCustomError(maybeError: unknown): CustomError {
  if (isCustomError(maybeError)) return maybeError;

  try {
    return new Error(JSON.stringify(maybeError));
  } catch {
    return new Error(String(maybeError));
  }
}

export const getErrorMessage = (error: unknown) => {
  return toCustomError(error).message;
};

export const getBackendErrors = (error: unknown) => {
  return toCustomError(error).errors;
};

export const getPlainError = (error: unknown) => {
  return toCustomError(error).error;
};
